export default __webpack_public_path__ + "static/media/apple_watch_7.595ff74f.png";